//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import themeConfig from '@themeConfig'
import { useUtils } from '@core/libs/i18n'
import { ref, getCurrentInstance } from '@vue/composition-api'
import { copyText } from 'vue3-clipboard'
import { success, error } from '@core/utils/toasted'
import { isMobile } from '@core/utils'
import { mdiChatOutline, mdiPhone } from '@mdi/js'

export default {
  setup() {
    const { t } = useUtils()
    const vm = getCurrentInstance().proxy
    const phoneNumber = ref('+18889653262')
    const phoneNumberText = ref('(888) 965-3262')

    const openChat = () => {
      if (!window.fcWidget.isOpen()) {
        window.fcWidget.open()
      } else {
        window.fcWidget.close()
      }
    }

    const copy = () => {
      if (isMobile()) {
        window.open(`tel:${phoneNumber.value}`)
      } else {
        copyText(phoneNumber.value, undefined, e => {
          if (e) {
            error(vm.$t('tooltip.not_copy'))
          } else {
            success(vm.$t('tooltip.copied'))
          }
        })
      }
    }

    return {
      alternateIcon: themeConfig.menu.groupChildIcon,
      phoneNumber,
      phoneNumberText,

      openChat,
      copy,

      // i18n
      t,

      // Icons
      icons: {
        mdiChatOutline,
        mdiPhone,
      },
    }
  },
}
